<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-12">
    <h3
      v-if="isCheckoutFlow"
      class="cf-title cf-title--3 cf-text-align-left"
    >
      {{ content.PaymentScreen.metadata.cardInfo }}
    </h3>

    <div
      v-if="isLoadingPaymentSdk"
      class="cf-section-loader-container"
    >
      <div class="cf-loader" />
    </div>

    <template v-else>
      <cf-square-credit-card-form
        v-if="paymentGateway.providers['Square']"
        ref="cardInformation"
        :payment-gateway="paymentGateway"
        :skip-required-validation="skipRequiredValidation"
        @error="cardInformationError"
        @interacted="cardInformationInteraction"
        @success="cardInformationSuccess"
      />

      <cf-stripe-credit-card-form
        v-else-if="paymentGateway.providers['Stripe']"
        ref="cardInformation"
        :payment-gateway="paymentGateway"
        :skip-required-validation="skipRequiredValidation"
        @error="cardInformationError"
        @interacted="cardInformationInteraction"
        @success="cardInformationSuccess"
      />

      <cf-default-credit-card-form
        v-else
        ref="cardInformation"
        :is-checkout-flow="isCheckoutFlow"
        :require-billing-address="requireBillingAddress"
        :tds-provider="tdsProvider"
        :skip-required-validation="skipRequiredValidation"
        @error="cardInformationError"
        @interacted="cardInformationInteraction"
        @success="cardInformationSuccess"
      />
    </template>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfSquareCreditCardForm from './cf-square-credit-card-form/index.vue';
  import CfStripeCreditCardForm from './cf-stripe-credit-card-form/index.vue';
  import CfDefaultCreditCardForm from './cf-default-credit-card-form/index.vue';

  import loadPaymentSDK from '@/helpers/load-payment-sdk';


  export default {
    name: 'CfCreditCardForm',

    components: {
      CfSquareCreditCardForm,
      CfStripeCreditCardForm,
      CfDefaultCreditCardForm
    },

    inject: {
      $validator: {
        from: '$validator'
      }
    },

    props: {
      isCheckoutFlow: {
        type: Boolean,
        default: true
      },

      paymentGateway: {
        type: Object,
        required: true
      },

      tdsProvider: {
        type: String,
        default: ''
      },

      requireBillingAddress: {
        type: Boolean,
        default: false
      },

      skipRequiredValidation: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        isLoadingPaymentSdk: false
      };
    },

    computed: {
      ...mapGetters('content', ['content'])
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        if (!this.isCheckoutFlow) {
          this.getPaymentSdk();
        }
      },

      async getPaymentSdk() {
        this.isLoadingPaymentSdk = true;
        await loadPaymentSDK(this.paymentGateway);
        this.isLoadingPaymentSdk = false;
      },

      cardInformationSuccess(data) {
        this.$emit('success', data);
      },

      cardInformationInteraction() {
        this.$emit('interacted');
      },

      cardInformationError(error) {
        this.$emit('error', error);
      },

      submit() {
        this.$refs.cardInformation.submit();
      }
    }
  };
 </script>

